import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Publications from './pages/Publications';
import News from './pages/News';
import FloraFauna from './pages/FloraFauna';
import Travel from './pages/Travel';
import DistrictPage from './pages/DistrictPage';
import Contact from './pages/Contact';
import CategoryDetails from './pages/CategoryDetails';
import SpeciesDetails from './pages/SpeciesDetails';
import PlaceDetails from './pages/PlaceDetails';
import FamilyDetails from './pages/FamilyDetails';
import GenusDetails from './pages/GenusDetails';

/* Admin Imports */
import AdminLayout from './admin/layouts/AdminLayout';
import Login from './admin/pages/Login';
import Dashboard from './admin/pages/Dashboard';
import ProtectedRoute from './admin/components/ProtectedRoute';
import ManageNews from './admin/pages/ManageNews';
import ManageSpecies from './admin/pages/ManageSpecies';
import ManageUsers from './admin/pages/ManageUsers';
import ManagePartners from './admin/pages/ManagePartners';
import ManagePublications from './admin/pages/ManagePublications';
import ManageDistricts from './admin/pages/ManageDistricts';
import ManageTravel from './admin/pages/ManageTravel';
import ManageFamilies from './admin/pages/ManageFamilies';
import ManageGenera from './admin/pages/ManageGenera';
import ManageTeam from './admin/pages/ManageTeam';
import ManageAboutContent from './admin/pages/ManageAboutContent';

// Public Layout with Navbar
const PublicLayout = () => (
  <div className="min-h-screen bg-white dark:bg-slate-950 transition-colors duration-300">
    <Navbar />
    <main>
      <Outlet />
    </main>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Routes - No Navbar, Custom Layout */}
        <Route path="/admin/login" element={<Login />} />

        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="news" element={<ManageNews />} />
          <Route path="species" element={<ManageSpecies />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="partners" element={<ManagePartners />} />
          <Route path="publications" element={<ManagePublications />} />
          <Route path="districts" element={<ManageDistricts />} />
          <Route path="families" element={<ManageFamilies />} />
          <Route path="genera" element={<ManageGenera />} />
          <Route path="travel" element={<ManageTravel />} />
          <Route path="team" element={<ManageTeam />} />
          <Route path="about" element={<ManageAboutContent />} />
          {/* Add more admin routes here */}
        </Route>

        {/* Public Routes - With Navbar */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/news" element={<News />} />
          <Route path="/flora-fauna" element={<FloraFauna />} />
          <Route path="/flora-fauna/category/:categoryId" element={<CategoryDetails />} />
          <Route path="/flora-fauna/family/:familyId" element={<FamilyDetails />} />
          <Route path="/flora-fauna/genus/:genusId" element={<GenusDetails />} />
          <Route path="/flora-fauna/species/:speciesId" element={<SpeciesDetails />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/travel/district/:id" element={<DistrictPage />} />
          <Route path="/travel/place/:id" element={<PlaceDetails />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </Router >
  );
}

export default App;
